import React, {Component} from 'react';
import FeaturedArticle from './FeaturedArticle';
import {HomeRouteContext} from '../../utils/context';
import {removeFalsyValuesInArray} from '../../utils/utils';
import './FeaturedArticlesSection.less';

class FeaturedArticlesSection extends Component {
    render() {
        const {id, title, articles, ...rest} = this.props;
        const filteredArticles = removeFalsyValuesInArray(articles);
        if (filteredArticles.length) {
            return (
                <section
                    id={id}
                    className="FeaturedArticlesSection hub-section"
                >
                    <h2 className="FeaturedArticlesSection__title">{title}</h2>
                    <div className="FeaturedArticlesSection__wrapper">
                        <HomeRouteContext.Consumer>
                            {(homeRoute) =>
                                filteredArticles.map((article, idx) => (
                                    <FeaturedArticle
                                        homeRoute={homeRoute}
                                        key={idx}
                                        {...article}
                                        {...rest}
                                    />
                                ))
                            }
                        </HomeRouteContext.Consumer>
                    </div>
                </section>
            );
        }
        return null;
    }
}

export default FeaturedArticlesSection;
